import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import HighmarkLogo from "../../../assets/images/highmark/ffb-logo.jpg";
import WinLogo from "../../../assets/images/win/logo-win.svg";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Referral_Source = () => {

    const [selected, setSelected] = useState("Broadstone");
    const navigate = useNavigate();

    const location = useLocation();
    const {updatedProviderData,otherData} = location.state;
    debugger;
    // Load logo the same way PatientConsentForm does
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const handleBack = () => {
        navigate('/patientconsent-form', { state: { updatedFormData: updatedProviderData, otherData: {...otherData, referralSource: selected} } });
    };

    useEffect(() => {
        if (otherData && otherData.referralSource) {
            setSelected(otherData.referralSource);
        }
    }, [otherData]);
    
    const onNextClick = async () => {
        navigate('/services', { state: {updatedProviderData, otherData: {...otherData, referralSource: selected }} });
    };

    return (
        <>
            {/* Header copied from PatientConsentForm */}
            <header>
                <nav className="navbar navbar-expand-lg container-fixed">
                    <a className="navbar-brand" href="#">
                        <img
                            src={isHighmarkPortal ? HighmarkLogo : WinLogo}
                            alt="Portal Logo"
                            className="logo brand-logo"
                        />
                    </a>
                </nav>
            </header>

            {/* Page Content */}
            <div className="registration-block-main patient-consent-screen">

                <div className="registration-form-main">
                    <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
                        <button onClick={handleBack} className="win-back-btn">
                            <span>
                                <i className="bi bi-chevron-left"></i>
                                Back
                            </span>
                        </button>
                    </div>
                    <div className="registration-form">
                        <div className="registration-process-form-wrapper mt-5">


                            <h3 className="page-heading-secondary-black-500 mt-4 mb-5">
                                How did you hear about <span className="page-heading-bold">WIN</span>?
                            </h3>

                            {/* Option 1 */}
                            <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
                                <input
                                    type="radio"
                                    className="form-check-input radio-btn win-form-check-input"
                                    id="option1"
                                    name="referral"
                                    value="Broadstone"
                                    checked={selected === "Broadstone"}
                                    onChange={(e) => setSelected(e.target.value)}
                                />
                                <label htmlFor="option1" className="multistep-form-radio-checkbox-label">
                                    Broadstone
                                </label>
                            </div>

                            {/* Option 2 */}
                            <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
                                <input
                                    type="radio"
                                    className="form-check-input radio-btn win-form-check-input"
                                    id="option2"
                                    name="referral"
                                    value="IVF Network"
                                    checked={selected === "IVF Network"}
                                    onChange={(e) => setSelected(e.target.value)}
                                />
                                <label htmlFor="option2" className="multistep-form-radio-checkbox-label">
                                    IVF Network (IVFN fertility treatment)
                                </label>
                            </div>

                            {/* Option 3 */}
                            <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
                                <input
                                    type="radio"
                                    className="form-check-input radio-btn win-form-check-input"
                                    id="option3"
                                    name="referral"
                                    value="Fertility Network (UK)"
                                    checked={selected === "Fertility Network (UK)"}
                                    onChange={(e) => setSelected(e.target.value)}
                                />
                                <label htmlFor="option3" className="multistep-form-radio-checkbox-label">
                                    Fertility Network (UK)
                                </label>
                            </div>

                            {/* Option 4 */}
                            <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
                                <input
                                    type="radio"
                                    className="form-check-input radio-btn win-form-check-input"
                                    id="option4"
                                    name="referral"
                                    value="Google"
                                    checked={selected === "Google"}
                                    onChange={(e) => setSelected(e.target.value)}
                                />
                                <label htmlFor="option4" className="multistep-form-radio-checkbox-label">
                                    Google
                                </label>
                            </div>

                            {/* Option 5 */}
                            <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
                                <input
                                    type="radio"
                                    className="form-check-input radio-btn win-form-check-input"
                                    id="option5"
                                    name="referral"
                                    value="Other"
                                    checked={selected === "Other"}
                                    onChange={(e) => setSelected(e.target.value)}
                                />
                                <label htmlFor="option5" className="multistep-form-radio-checkbox-label">
                                    Other
                                </label>
                            </div>

                            {/* Next Button */}
                            <div className="mt-5">
                                <button onClick={onNextClick} className="win-btn-primary mobile-view">
                                    Next
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default Referral_Source;
